<template>
    <div id="app" class="fixed-menu" v-bind:class="{
        'rms-app': generalOptions.app_id == 1,
        'rmb-app': generalOptions.app_id == 2,
        'rml-app': generalOptions.app_id == 5,
        'sales-page': salesPage,
        'get-started-page': salesGetStartedPage,
        'sales-signup-page': salesSignupPage,
        'fixed-menu': !salesPage && !salesGetStartedPage && !salesSignupPage,
    }">
        <AppHeader v-if="!is_admin" />
        <AdminHeader v-if="is_admin" />
        <Sidebar v-if="is_admin" />
        <div class="container main-container full-width" :class="{
            'has-side-menu': is_admin,
            'sidebar-collapsed': sidebarCollapse,
        }">
            <div class="router-container">
                <router-view :key="$route.fullPath"></router-view>
            </div>
        </div>
        <AppFooter :class="{
            'admin-footer': is_admin,
            'sidebar-collapsed': sidebarCollapse,
        }" />
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AdminHeader from "./components/admin/Header.vue";
import Sidebar from "./components/admin/Sidebar.vue";
import AppFooter from "./components/AppFooter.vue";
import eventBus from "./services/eventBus.js";
import api from "./services/apiEndpoints.js";
import store from "./services/vuex.js";

export default {
    name: "app",
    data: function () {
        return {
            is_admin: false,
            sidebarCollapse: true,
            salesPage: false,
            salesGetStartedPage: false,
            salesSignupPage: false,
        };
    },
    mounted: function () {
        document.title = this.generalOptions.app_title + " | " + this.generalOptions.app_name;
        this.checkAdmin();

        this.salesPage = this.$route.fullPath == "/sales";
        this.salesGetStartedPage = this.$route.fullPath == "/get-started";
        this.salesSignupPage = this.$route.fullPath == "/sign-up";

        this.$nextTick(function () {
            var link = document.querySelector("link[rel*='icon']");
            if (this.generalOptions.app_id != 1) {
                link.href = "/fvicon-" + this.generalOptions.app_id + ".png";
            } else {
                link.href = "/fvicon.png";
            }
        });

        eventBus.on("user_profile_loaded", this.checkAdmin);
        eventBus.on("user_logged_out", this.checkAdmin);
        eventBus.on("admin_route_loaded", this.checkAdmin);
        eventBus.on("check_admin_section", this.checkAdmin);
        eventBus.on("admin_sidebar_collapse", (collapse) => {
            this.sidebarCollapse = collapse;
        });

        var urlParams = new URLSearchParams(window.location.search);
        var params = Object.fromEntries(urlParams.entries());

        if (params.auth && params.profile) {
            window.location.href = window.location.origin + window.location.pathname;
        }

        //this.getTranslation();
    },

    beforeUnmount() {
        eventBus.off("user_profile_loaded", this.checkAdmin);
        eventBus.off("user_logged_out", this.checkAdmin);
        eventBus.off("admin_route_loaded", this.checkAdmin);
    },
    computed: {
        translation: {
            get: function () {
                return this.$store.state.translation;
            },
            set: function (value) {
                this.$store.commit("setTranslation", value);
            },
        },
    },
    methods: {
        checkAdmin: function () {
            let token = JSON.parse(localStorage.getItem("token"));

            // get the URL pathname with the help of URL object
            // and replace `this.$route.path` with the new pathname
            // because `this.$route.path` was returning '/' all the time
            const url = new URL(window.location.href);
            const urlPathname = url.pathname;

            if (urlPathname.indexOf("/app") !== -1 && token) {
                this.is_admin = true;
            } else {
                this.is_admin = false;
            }
        },
        getTranslation: function () {
            this.$http.get(api.actions.get_translation).then(
                function (response) {
                    if (typeof response.data == "object") {
                        this.translation = response.data;
                    }
                }.bind(this)
            );
        },
       
    },
    components: {
        AppHeader,
        AdminHeader,
        Sidebar,
        AppFooter,
    },
};
</script>

<style lang="scss">
@use "./assets/scss/Main.scss";
</style>